
import React from 'react'

import { composeClassName } from '../../utils/common'
import AvatarImage from '../../utils/AvatarImage'
import MessageIndicators from '../MessageIndicators'
import { MessageProps } from '../../../MessageDisplayArea'
import MessageTime from '../MessageTime'
import Spinner from '../Spinner'

const OperatorMessage: React.FC<MessageProps> = props => {
  const {
    message: {
      id,
      nickname,
      renderText,
      originalText,
      subtype,
      type,
      isFirstInGroup,
      isLastInGroup,
    },
    renderParams: {
      imgParams,
      nextMessageParams,
      contextMenuForOperatorMessages,
    },
    common: {
      messageViewType,
    }
  } = props;

  const res = (
    <div className={composeClassName(type!, isFirstInGroup, isLastInGroup, nextMessageParams)}>
      <AvatarImage {...{ messageViewType, imgParams, nickname }} />

      <div className="message-content">

        {
          isFirstInGroup
            && (
              <p className="author">
                {nickname}
              </p>
            )
        }
        {<MessageTime {...props} />}

        <div className="message-text">
          {renderText('span')}
          <MessageIndicators {...props} />
        </div>

        { <Spinner {...props}/> }
      </div>
    </div>
  )
  
  return contextMenuForOperatorMessages && id !== undefined
    ? contextMenuForOperatorMessages({ children: res, id, originalText, nickname, subtype })
    : res
}

export default OperatorMessage
